/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_header = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Load
		*/
		specific_header.load(
			url[1]
		);

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.load = function(
		_header_type
	) {

		switch(_header_type) {

			default:
				_header_type = 'homepage';				
			break;

			case 'account':
				_header_type = 'account';
			break;

			case 'admin':
				_header_type = 'admin';
			break;

		}

		/*
		Only load when type is differt one
		*/
		if(is_header_type != _header_type) {

			/*
			Set: Body background
			*/
			switch(_header_type) {

				default:
					$('body').removeClass('yellow-body,darkred-body');
				break;

				case 'account':
					$('body').addClass('yellow-body');
				break;

				case 'admin':
					$('body').addClass('darkred-body');
				break;

			}
			
			/*
			Load header
			*/
			$.ajax({
				url: globalUrl + '/a/l/header',
				type: "POST",
				data: {
					type		: _header_type
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				$('header').html(data);

				is_header_type = _header_type;

			});

			/*
			Load mobilemenmu
			*/
			$.ajax({
				url: globalUrl + '/a/l/mobilemenu',
				type: "POST",
				data: {
					type		: _header_type
				},
				headers: { 
					'go-load':1 
				}
			})
			.done(function(data) {

				$('.js-mobile-menu-inside').html(data);

				is_header_type = _header_type;

				specific_interactions.catchAndActiveURL();

			});

		} else {

			specific_interactions.catchAndActiveURL();
			
		}

	};
			
}).apply(specific_header); 